export default __webpack_public_path__ + "static/referral-background-a448cee7c03ebfd98cd84c3cf8a0dacf.png";